'use client'

import { createTRPCContext } from '@trpc/tanstack-react-query'
import type { AppRouter } from '@/backend/serverApi'

export const { TRPCProvider, useTRPC, useTRPCClient } = createTRPCContext<AppRouter>()
